import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, Row, Col, Spin, Alert } from 'antd';
import { UserOutlined, LockOutlined, LoadingOutlined } from '@ant-design/icons';
import * as userActions from '../../redux/actions/userActions';
import { connect } from 'react-redux';
import Logo from '../../assets/images/logo-img.png';
import { useLocation, useNavigate } from 'react-router-dom';
const ResetPassword = props => {
  const navigate = useNavigate();
  const [requiredToken, setToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMsg, setSuccesMsg] = useState('');
  const token = useLocation().search.split('=')[1];
  useEffect(() => {
    setToken(token);
  }, []);
  const onFinish = async values => {
    setErrorMessage('');
    setSuccesMsg('');
    try {
      setLoading(true);
      await props.passwordReset(values.email);
      setSuccesMsg('Reset password link has been sent on your email successfully!');
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrorMessage('');
      console.log('||Error: ', error);
    }
  };

  const onFinish1 = async values => {
    setErrorMessage(false);
    setSuccesMsg('');
    setLoading(true);
    props
      .resetPassword(requiredToken, values.password)
      .then(
        res => {
          if (res.errors == undefined) {
            setSuccesMsg('Password has been reset successfully!');
            setTimeout(() => {
              navigate('/login');
            }, 2500);
            setLoading(false);
          }
        },
        errorResponse => {
          setLoading(false);
          if (errorResponse.errors !== undefined) {
            for (var i = 0; i < errorResponse.errors.length; i++) {
              var errorObj = errorResponse.errors[i];
              if (errorObj.extensions.code == 'FORBIDDEN') {
                setErrorMessage('Link has been used already!');
              } else if (errorObj.extensions.code == 'INTERNAL_SERVER_ERROR') {
                setErrorMessage('Link has been expired!');
              } else {
                setErrorMessage('Unexpected error please try again');
              }
            }
            setLoading(false);
          }
          return errorResponse;
        }
      )
      .catch(error => {
        setLoading(false);
        setErrorMessage('Error!!!');
        setSuccesMsg(false);
      });
    return true;
  };
  let render = () => {
    let { status } = props;
    return (
      <Row className="login-p">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div className="login-section">
            <div className="form-card">
              <div className="logo">
                <img src={Logo} alt="Ansel Adams" />
              </div>
              <div className="form-heading">Reset Password</div>
              <div className="form-section">
                {errorMessage != '' ? (
                  <div style={{ margin: '20px auto' }}>
                    <Alert type="error" message={errorMessage} />
                  </div>
                ) : (
                  ''
                )}
                {successMsg != '' ? (
                  <div style={{ margin: '20px auto' }}>
                    <Alert type="success" message={successMsg} />
                  </div>
                ) : (
                  ''
                )}
                {!requiredToken ? (
                  <Form className="log-in-form" layout="vertical" onFinish={onFinish}>
                    <Form.Item
                      label="Email address"
                      name="email"
                      rules={[
                        { required: true, message: 'Please input your email!' },
                        { type: 'email', message: 'Please input valid email!' },
                      ]}
                    >
                      <Input type="email" prefix={<UserOutlined className="prefix-icon" />} />
                    </Form.Item>
                    <div style={{ textAlign: 'right' }}>
                      <a className="link-text" href="/login">
                        Back to Login
                      </a>
                    </div>
                    <Spin spinning={loading} size="large" indicator={<LoadingOutlined />}>
                      <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-button">
                          Send
                        </Button>
                      </Form.Item>
                    </Spin>
                  </Form>
                ) : (
                  <Form className="otp-form" layout="vertical" onFinish={onFinish1}>
                    <Form.Item
                      label="Password"
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: 'Please input your new password!',
                        },
                        ({ getFieldValue }) => ({
                          validator(rule, value) {
                            if (!!value && value.length < 6) {
                              return Promise.reject('Password should be greater than or equal to 6 characters!');
                            } else if (!!value && value.length > 16) {
                              return Promise.reject('Password should be less than or equal to 16 characters!');
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                      hasFeedback
                    >
                      <Input.Password prefix={<LockOutlined className="prefix-icon" />} />
                    </Form.Item>
                    <Form.Item
                      label="Confirm Password"
                      name="confirm_password"
                      dependencies={['password']}
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          message: 'Please confirm your new password!',
                        },
                        ({ getFieldValue }) => ({
                          validator(rule, value) {
                            if (!value || getFieldValue('password') === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject('Password should be same!');
                          },
                        }),
                      ]}
                    >
                      <Input.Password prefix={<LockOutlined className="prefix-icon" />} />
                    </Form.Item>
                    <div style={{ textAlign: 'right' }}>
                      <a className="link-text" href="/login">
                        Back to Login
                      </a>
                    </div>
                    <Spin spinning={loading} size="large" indicator={<LoadingOutlined />}>
                      <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-button">
                          Submit
                        </Button>
                      </Form.Item>
                    </Spin>
                  </Form>
                )}
              </div>
            </div>
            <div className="copyright">&copy;2010-2022 The Anseladams Gallery. All rights reserved.</div>
          </div>
        </Col>
      </Row>
    );
  };
  return render();
};
export default connect(state => {
  return {
    ...state.status,
    ...state.user,
  };
}, userActions)(ResetPassword);
